var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVentilationOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9824 20.6185C35.0145 20.6185 35.9904 20.8244 36.9217 21.1286V19.0201C36.9217 14.6111 40.3315 11.0191 44.5207 11.0191C48.7402 11.0191 52.173 14.6324 52.173 19.074H57.9441C57.9441 11.9693 51.9201 6.18616 44.5182 6.18616C37.1487 6.18616 31.1553 11.9432 31.1553 19.0201V21.0935C32.0539 20.8127 32.99 20.6184 33.9823 20.6184L33.9824 20.6185Z",
    fill: "url(#paint0_linear_35070_638)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2706 29.3738L24.2575 29.9828C24.2523 29.0413 24.3432 28.0901 24.6333 27.1437C24.9365 26.1547 25.4194 25.282 25.9832 24.4806L23.9605 23.8606C19.7451 22.5685 17.3119 18.2563 18.5396 14.251C19.7762 10.2168 24.2369 7.99363 28.4835 9.29532L30.1726 3.77702C23.3798 1.69485 16.0852 5.75945 13.9159 12.8363C11.7561 19.8823 15.5039 27.2997 22.2701 29.3737L22.2706 29.3738Z",
    fill: "url(#paint1_linear_35070_638)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4845 24.2542L41.5577 24.8108C42.1084 25.6212 42.5771 26.5016 42.8641 27.4954C43.1388 28.4464 43.2126 29.4019 43.1938 30.3403L45.0869 29.7934C49.3092 28.5738 53.8562 30.9411 55.0161 34.9566C56.1871 39.0104 53.6683 43.3111 49.4034 44.543L51.0027 50.088C57.8284 48.1164 61.7127 40.7242 59.6593 33.6153C57.5961 26.4725 50.3398 22.2739 43.4845 24.2541L43.4845 24.2542Z",
    fill: "url(#paint2_linear_35070_638)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.992 38.8898C27.1657 38.3406 26.4936 37.6606 25.9007 36.9292L24.8125 38.5663C22.3795 42.2264 17.3801 43.3599 13.8992 41.0461C10.3852 38.7103 9.52661 33.8008 11.984 30.1038L7.17795 26.9091C3.24494 32.8259 5.0603 40.9768 11.2226 45.073C17.4143 49.1887 25.6646 47.701 29.6148 41.7585L30.7224 40.0921C29.7783 39.8299 28.8516 39.4612 27.9921 38.8899L27.992 38.8898Z",
    fill: "url(#paint3_linear_35070_638)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9845 21.7579C29.3508 21.7579 25.5947 25.5163 25.5947 30.1501C25.5947 34.7862 29.3508 38.5423 33.9845 38.5423C38.6183 38.5423 42.3695 34.7863 42.3695 30.1501C42.3695 25.5165 38.6158 21.7579 33.9845 21.7579V21.7579ZM33.9845 36.1435C30.6731 36.1435 27.9911 33.4616 27.9911 30.1501C27.9911 26.8387 30.6731 24.1567 33.9845 24.1567C37.2936 24.1567 39.9732 26.8387 39.9732 30.1501C39.9732 33.4616 37.2936 36.1435 33.9845 36.1435Z",
    fill: "url(#paint4_linear_35070_638)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0233 38.5425C38.2004 39.0969 37.3154 39.4588 36.4132 39.728L37.5115 41.3583C39.9669 45.0034 39.1077 50.0572 35.6412 52.3924C32.1417 54.7498 27.2758 53.6709 24.7957 49.9891L20.0093 53.2133C23.9787 59.1058 32.2058 60.5367 38.3427 56.4026C44.509 52.2488 46.2807 44.0548 42.294 38.1367L41.1762 36.4772C40.5736 37.2499 39.8793 37.9659 39.0234 38.5425L39.0233 38.5425Z",
    fill: "url(#paint5_linear_35070_638)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9828 27.1522C32.3283 27.1522 30.9873 28.4955 30.9873 30.1501C30.9873 31.8069 32.3283 33.1479 33.9828 33.1479C35.6373 33.1479 36.9783 31.8069 36.9783 30.1501C36.9783 28.4955 35.6373 27.1522 33.9828 27.1522Z",
    fill: "url(#paint6_linear_35070_638)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35070_638",
    x1: 51.016,
    y1: 10.033,
    x2: 40.4898,
    y2: 34.0865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35070_638",
    x1: 26.4264,
    y1: 9.842,
    x2: -1.83632,
    y2: 19.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35070_638",
    x1: 54.1263,
    y1: 28.39,
    x2: 35.5262,
    y2: 51.7014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35070_638",
    x1: 22.798,
    y1: 39.4439,
    x2: 0.723362,
    y2: 53.6938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35070_638",
    x1: 38.0313,
    y1: 26.0789,
    x2: 22.3952,
    y2: 45.9974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35070_638",
    x1: 37.5544,
    y1: 43.5552,
    x2: 42.3072,
    y2: 69.3963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_35070_638",
    x1: 35.4289,
    y1: 28.6958,
    x2: 29.8432,
    y2: 35.8099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentilationOrangeIcon);
export default __webpack_public_path__ + "static/media/ventilation_orange_icon.5963a8d3bba83c4f9f1c13db487e7a01.svg";
export { ForwardRef as ReactComponent };